// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uXVtEx5x50Kdsu {
  height: 32px;
  margin-right: var(--ds-space-050, 4px);
  margin-bottom: var(--ds-space-0, 0px);
}
`, ""]);
// Exports
export var joinButton = `uXVtEx5x50Kdsu`;
export default ___CSS_LOADER_EXPORT___;
